export default __webpack_public_path__ + "static/media/adachatai.0988e628.png";